import React from 'react';
import './EditAddress.css';
import EnterAddress from '../SignUpFlow/EnterAddress/EnterAddress';

function EditAddress() {
    return (
        <div className="EditAddress">
            <div className="editAddressContainer">
                <div className="editAddressCard">
                    <EnterAddress signUp={false} />
                </div>
            </div>
        </div>
    );
}

export default EditAddress;
